import React from 'react';
import { Stack, Title, Text, List } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <Stack p="xl" maw={800} mx="auto">
      <Title order={2} fw={800}>{t('legal.privacy.title')}</Title>
      {Object.entries(t('legal.privacy.sections', { returnObjects: true })).map(
        ([key, section]) => (
          <div key={key}>
            <Title order={3}>{section.title}</Title>
            {section.content && <Text mt="xs">{section.content}</Text>}
            {section.list && (
              <List mt="xs">
                {section.list.map((item, index) => (
                  <List.Item key={index}>{item}</List.Item>
                ))}
              </List>
            )}
            {section.subsections &&
              section.subsections.map((subsection, index) => (
                <div key={index} mt="sm">
                  <Title order={4} mt="md">
                    {subsection.title}
                  </Title>
                  {subsection.content && (
                    <Text mt="xs">{subsection.content}</Text>
                  )}
                  {subsection.list && (
                    <List mt="xs">
                      {subsection.list.map((item, idx) => (
                        <List.Item key={idx}>{item}</List.Item>
                      ))}
                    </List>
                  )}
                </div>
              ))}
          </div>
        )
      )}
    </Stack>
  );
};

export default PrivacyPolicy; 